import { render } from "./addRespnse.vue?vue&type=template&id=3dcc53e2&scoped=true"
import script from "./addRespnse.vue?vue&type=script&lang=js"
export * from "./addRespnse.vue?vue&type=script&lang=js"

import "./addRespnse.vue?vue&type=style&index=0&id=3dcc53e2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3dcc53e2"]])

export default __exports__